import React from 'react';
import AxiosInstance from '../../server/AxioInstance';
import MenuButton from '../../components/common/menuButton/MenuButton';
import { Grid } from '@mui/material';
import { PendingActionsIcon, TaskIcon, HowToRegIcon, UpdateIcon } from '../../shared/components/icon';
import { ReportDialog } from '../../components/Dialog/ReportDialog';
import { useSnackbar, useDialog } from '../../shared/context';
import * as XLSX from 'xlsx';

export const ReportPage = () => {
  const { isDialogOpen, openDialog, closeDialog, dialogData } = useDialog('reportDialog');
  const { showSnackbar } = useSnackbar();

  const handleCloseDialog = () => closeDialog();
  const handleConfirmAction = handleCloseDialog;
  const handleCancelAction = handleCloseDialog;

  const standByMsg = () => {
    showSnackbar({
      vertical: 'top',
      horizontal: 'right',
      message: 'Gerando relatório Aguarde...',
      variant: 'info',
    });
  };

  const errorMsg = (msg) => {
    showSnackbar({
      vertical: 'top',
      horizontal: 'right',
      message: msg,
      variant: 'error',
    });
  };

  const successMsg = (msg) => {
    showSnackbar({
      vertical: 'top',
      horizontal: 'right',
      message: msg,
      variant: 'success',
    });
  };

  const handleReport = async (route) => {
    standByMsg();
    try {
      const result = await AxiosInstance.get(route);
      handlexlsx(result.data);
    } catch (error) {
      errorMsg(`${error.message}`);
    }
  };

  const handleReportTrainingDIalog = () => {
    openDialog({});
  };

  const handlexlsx = (data) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = {
      Sheets: {
        pasta1: worksheet,
      },
      SheetNames: ['pasta1'],
    };
    XLSX.writeFile(workbook, `Relatório.xlsx`);
    successMsg('Relatório gerado com sucesso');
  };

  return (
    <>
      {isDialogOpen() && (
        <ReportDialog
          handleClose={handleCloseDialog}
          handleConfirm={handleConfirmAction}
          handleCancel={handleCancelAction}
          dialogData={dialogData}
          handlexlsx={handlexlsx}
        />
      )}

      <Grid container spacing={1}>
        <Grid item key="Usuário por setor" xs={12} sm={6} md={4}>
          <MenuButton
            title="Usuário por setor"
            icon={<PendingActionsIcon color="primary" sx={{ fontSize: '10em' }} />}
            onClick={() => handleReport('/report/report-sector-user')}
          />
        </Grid>
        <Grid item key="Documentos por permissão" xs={12} sm={6} md={4}>
          <MenuButton
            title="Documentos por permissão"
            icon={<TaskIcon color="primary" sx={{ fontSize: '10em' }} />}
            onClick={() => handleReport('/report/report-document-view')}
          />
        </Grid>
        <Grid item key="Lista de presença – treinamento" xs={12} sm={6} md={4}>
          <MenuButton
            title="Lista de presença – treinamento"
            icon={<HowToRegIcon color="primary" sx={{ fontSize: '10em' }} />}
            onClick={handleReportTrainingDIalog}
          />
        </Grid>
        <Grid item key="Pessoas com notificações em AVISOS" xs={12} sm={6} md={4}>
          <MenuButton
            title="Pessoas com notificações em AVISOS"
            icon={<UpdateIcon color="warning" sx={{ fontSize: '10em' }} />}
            onClick={() => handleReport('/report/report-pending')}
          />
        </Grid>
        <Grid item key="Log visualização de documentos" xs={12} sm={6} md={4}>
          <MenuButton
            title="Log visualização de documentos"
            icon={<TaskIcon color="secundary" sx={{ fontSize: '10em' }} />}
            onClick={() => handleReport('/report/log-view-documents?login=' + localStorage.getItem('@gedy:user'))}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ReportPage;
